import entry from "./capital/entry.js";
import account from "./capital/account.js";
import subject from "./capital/subject.js";
import report from "./capital/report.js";
import data from "./capital/data.js";

export default {
    entry,
    account,
    subject,
    report,
    data
};